import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import '../styles/ExportVote.css';
import fr from '../locales/fr';
import en from '../locales/en';

function ExportVote({ ws }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedPlayer, setSelectedPlayer] = useState(null);

    // Fonction pour récupérer les réponses depuis le cookie
    const getPlayerResponsesFromCookie = () => {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name === 'playerResponses') {
                try {
                    return JSON.parse(decodeURIComponent(value));
                } catch (error) {
                    console.error('Error parsing playerResponses cookie:', error);
                    return {};
                }
            }
        }
        return {};
    };

    // Fonction pour sauvegarder les réponses dans le cookie
    const savePlayerResponsesToCookie = (responses) => {
        const cookieValue = encodeURIComponent(JSON.stringify(responses));
        // Cookie expire dans 24 heures
        const expires = new Date();
        expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000);
        document.cookie = `playerResponses=${cookieValue}; expires=${expires.toUTCString()}; path=/`;
    };

    const [playerResponses, setPlayerResponses] = useState(getPlayerResponsesFromCookie());
    const browserLang = navigator.language || navigator.userLanguage;

    const allowed =
        location.state?.fromAuthorized ||
        sessionStorage.getItem('canAccessExportVote');
    const language = browserLang.startsWith('fr') ? 'fr' : 'en';
    const translations = language === 'fr' ? fr : en;

    const handleCheckboxChange = (player) => {
        setSelectedPlayer(player);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (selectedPlayer !== null) {
            try {
                var unityID = localStorage.getItem('UNITY');
                ws.send(unityID + ":VOþ" + selectedPlayer);
                // Supprimer le cookie playerResponses
                document.cookie = 'playerResponses=; expires=Thu, 05 Oct 2000 00:00:00 UTC; path=/;';
                setTimeout(() => {
                    sessionStorage.setItem('canAccessOnTV', 'true');
                    navigate("/onTV", { state: { fromAuthorized: true } });
                }, 20);
            } catch (error) {
                console.error('Error sending data via WebSocket:', error);
            }
        } else {
            alert(translations.exportVote.alertMessage);
        }
    };

    useEffect(() => {
        const handleWebSocketMessage = (event) => {
            const dataRecu = event.data;
            const ROOM = localStorage.getItem('UNITY');
            const messageComplet = dataRecu.split(":");

            switch (dataRecu) {
                case ROOM + ":START":
                    ws.onmessage = null;
                    ws.send(ROOM + ":CHECKSTATE");
                    sessionStorage.setItem('canAccessOnTV', 'true');
                    navigate("/onTV", { state: { fromAuthorized: true } });
                    break;
                case ROOM + ":ANSWER":
                    ws.onmessage = null;
                    ws.send(ROOM + ":CHECKSTATE");
                    sessionStorage.setItem('canAccessAnswer', 'true');
                    navigate("/answer", { state: { fromAuthorized: true } });
                    break;
                case ROOM + ":WAIT":
                    ws.onmessage = null;
                    ws.send(ROOM + ":CHECKSTATE");
                    sessionStorage.setItem('canAccessWaitingState', 'true');
                    navigate("/waitingState", { state: { fromAuthorized: true } });
                    break;
                case ROOM + ":CLOSE":
                    ws.onmessage = null;
                    ws.send(ROOM + ":CHECKSTATE");
                    sessionStorage.setItem('canAccessRestart', 'true');
                    navigate("/restart", { state: { fromAuthorized: true } });
                    break;
                default:
                    console.log("Message non reconnu:", dataRecu);
            }

            // Vérifier que messageComplet[1] existe avant de faire split
            if (messageComplet[1]) {
                const responseArray = messageComplet[1].split("þ");

                for (let i = 0; i < responseArray.length; i += 2) {
                    const player = responseArray[i];
                    const response = responseArray[i + 1];

                    setPlayerResponses(prevResponses => {
                        const updatedResponses = {
                            ...prevResponses,
                            [player]: response
                        };
                        savePlayerResponsesToCookie(updatedResponses);
                        return updatedResponses;
                    });
                }
            }
        };

        ws.onmessage = handleWebSocketMessage;

        return () => {
            ws.onmessage = null;
        };
    }, [ws]);

    useEffect(() => {
        if (allowed) {
            sessionStorage.removeItem('canAccessExportVote');
        }
    }, [allowed]);

    if (!allowed) {
        return <Navigate to="/" replace />;
    }

    const checkboxes = Object.keys(playerResponses).map((player, index) => (
        <div className="checkbox" key={player}>
            <input
                type="radio"
                id={`player-${player}`}
                name="player-selection"
                checked={selectedPlayer === player}
                onChange={() => handleCheckboxChange(player)}
            />
            <label htmlFor={`player-${player}`}>
                {playerResponses[player]}
            </label>
        </div>
    ));

    return (
        <div className="boxform">
            <h1 className="title">{translations.exportVote.title}</h1>
            <div>
                {checkboxes}
            </div>
            <button className="submit-button" onClick={handleSubmit}>{translations.exportVote.submit}</button>
        </div>
    );
}

export default ExportVote;
